import PropTypes from "prop-types";
import React, { useState } from "react";
import { setActiveSort } from "../../helpers/product";
import { Collapse } from "react-collapse";
import { Link } from "react-router-dom";
import { useEffect } from "react";

const ShopSubCategories = ({ subcategories, getSortParams }) => {
  //const [stateLista, setstateLista] = useState(global.aziendaID == 1? true : false);
  const [stateLista, setstateLista] = useState(false);
  const [subCategorySelected, setSubCategorySelected] = useState(
    JSON.parse(sessionStorage.getItem("filter"))?.subcategory?.split("|")
  );
  const [refresh, setRefresh] = useState(true);

  const CambioStato = () => {
    if (stateLista) setstateLista(false);
    else setstateLista(true);
  };
  useEffect(() => {
    setSubCategorySelected(
      JSON.parse(sessionStorage.getItem("filter"))?.subcategory?.split("|")
    );
    setRefresh(!refresh);
  }, [sessionStorage.getItem("filter")]);
  return (
    <div className="sidebar-widget">
      <div
        data-role="title"
        role="tab"
        aria-selected="false"
        aria-expanded="false"
        tabindex="-1"
        onClick={() => CambioStato()}
        style={{
          fontSize: "17px",
          color: "black",
          fontWeight: 600,
          cursor: "pointer",
          lineHeight: "30px",
        }}
      >
        <span
          class={
            stateLista
              ? "icon pe-7s-angle-down pull-right"
              : "icon pe-7s-angle-up pull-right"
          }
          data-role="icons"
          style={{ display: "inline-block" }}
        >
          {" "}
        </span>
        Sottocategorie
      </div>

      {/*<div className="shopping-cart-btn btn-hover text-center" style={{ padding: "10px" }}>
        <a style={{ padding: "10px", border: "1px gray solid", display: "block", width: "100%" }} onClick={() => CambioStato()}  >Genere</a>
  </div>*/}
      {/* <h4  <h4 className="btn btn-primary btn-xs" onClick={() => CambioStato()}>Marchi </h4>*/}

      <Collapse
        theme={{ collapse: "foo", content: "bar" }}
        isOpened={stateLista}
      >
        <div className="sidebar-widget-tag ">
          {subcategories ? (
            <ul>
              <li>
                <div className="sidebar-widget-list-left">
                  <button
                    id="allSubCategories"
                    onClick={(e) => {
                      document
                        .querySelectorAll(".subCategories")
                        .forEach((element) =>
                          element.classList.remove("active")
                        );
                      if (e.currentTarget.classList.contains("active"))
                        getSortParams("subcategory", "all", "-");
                      else getSortParams("subcategory", "all", "+");
                      //getSortParams("subcategory", "");
                      setActiveSort(e);
                    }}
                  >
                    <span className="checkmark" /> Tutte i generi
                  </button>
                </div>
              </li>
              {subcategories.map((subcategory, key) => {
                if (subcategory === "") return;
                return (
                  <li key={key}>
                    <div className="sidebar-widget-list-left">
                      <button
                        className={
                          "subCategories " +
                          (subCategorySelected?.find((v) => subcategory === v)
                            ? "active"
                            : "")
                        }
                        onClick={(e) => {
                          document
                            .querySelector("#allSubCategories")
                            .classList.remove("active");
                          if (e.currentTarget.classList.contains("active"))
                            getSortParams("subcategory", subcategory, "-");
                          else getSortParams("subcategory", subcategory, "+");
                          //getSortParams("subcategory", subcategory);
                          setActiveSort(e);
                        }}
                      >
                        {" "}
                        <span className="checkmark" /> {subcategory}{" "}
                      </button>
                    </div>
                  </li>
                );
              })}
            </ul>
          ) : null}
        </div>
      </Collapse>
    </div>
  );
};

ShopSubCategories.propTypes = {
  Subcategories: PropTypes.array,
  getSortParams: PropTypes.func,
};

export default ShopSubCategories;
